<template>
   <section  class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>
import Breadcrumb  from    '@/components/BreadcrumbComponent/Breadcrumb'
export default {
    props: [
        'breadcrumb'
    ],
    components: {
        Breadcrumb
    },

}
</script>
